/**
 * B.S.C. Laboratories — dose (variant) selector.
 *
 * Drives any element with [data-bsc-product-form] on the page (main product form and the
 * homepage quick-buy form). Reads variant data from an embedded JSON script tag, and on
 * dose change updates: hidden variant id, displayed price, SKU, quantity max (clamped to
 * available inventory), Add to Cart / Sold Out button state, and broadcasts a
 * "bsc:variant-change" event so the sticky mobile bar can stay in sync.
 *
 * Inventory + sold-out states always come from real Shopify variant data — nothing here
 * invents stock numbers.
 */
(function () {
  function initForm(formEl) {
    var dataEl = document.getElementById(formEl.getAttribute('data-bsc-variant-data'));
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var variantIdInput = formEl.querySelector('[name="id"]');
    var priceEl = formEl.querySelector('[data-bsc-price]');
    var skuEl = formEl.querySelector('[data-bsc-sku]');
    var statusEl = formEl.querySelector('[data-bsc-status]');
    var qtyInput = formEl.querySelector('[data-bsc-qty-input]');
    var qtyMinus = formEl.querySelector('[data-bsc-qty-minus]');
    var qtyPlus = formEl.querySelector('[data-bsc-qty-plus]');
    var submitBtn = formEl.querySelector('[data-bsc-submit]');
    var radios = formEl.querySelectorAll('[data-bsc-dose-radio]');

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    function currentVariant() {
      return findVariant(variantIdInput.value);
    }

    function updateOptionAvailability() {
      radios.forEach(function (radio) {
        var variant = findVariant(radio.value);
        var wrapper = radio.closest('.bsc-dose-option');
        if (!variant || !wrapper) return;
        wrapper.setAttribute('data-sold-out', variant.available ? 'false' : 'true');
        radio.disabled = !variant.available;
      });
    }

    function render() {
      var variant = currentVariant();
      if (!variant) return;

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (skuEl) skuEl.textContent = variant.sku || '';

      if (qtyInput) {
        var max = variant.inventory_management ? Math.max(variant.inventory_quantity, 0) : 999;
        qtyInput.max = variant.available ? max : 0;
        if (parseInt(qtyInput.value, 10) > max) qtyInput.value = Math.max(max, variant.available ? 1 : 0);
        if (parseInt(qtyInput.value, 10) < 1 && variant.available) qtyInput.value = 1;
      }

      if (submitBtn) {
        if (variant.available) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.getAttribute('data-bsc-label-available') || 'Add to Cart';
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = submitBtn.getAttribute('data-bsc-label-soldout') || 'Sold Out';
        }
      }

      if (statusEl) {
        if (!variant.available) {
          statusEl.textContent = 'This dose is currently sold out. The other dose may still be available.';
          statusEl.classList.add('bsc-status--soldout');
        } else {
          statusEl.textContent = '';
          statusEl.classList.remove('bsc-status--soldout');
        }
      }

      updateOptionAvailability();

      document.dispatchEvent(
        new CustomEvent('bsc:variant-change', {
          detail: {
            variant: variant,
            quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1,
            formId: formEl.id
          }
        })
      );
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.disabled) return;
        variantIdInput.value = radio.value;
        render();
      });
    });

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) {
          qtyInput.value = val - 1;
          render();
        }
      });
    }

    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        var max = parseInt(qtyInput.max, 10) || 999;
        if (val < max) {
          qtyInput.value = val + 1;
          render();
        }
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', render);
    }

    document.addEventListener('bsc:sticky-add-to-cart', function (e) {
      if (e.detail && e.detail.formId === formEl.id) {
        formEl.requestSubmit ? formEl.requestSubmit(submitBtn) : formEl.submit();
      }
    });

    render();
  }

  function init() {
    document.querySelectorAll('[data-bsc-product-form]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
